var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Tv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h11V41H56v23zm4.5-19h2a1.5 1.5 0 110 3h-2a1.5 1.5 0 110-3zM67 19v17h-4V19H13v28h38v4H40v9h11v4H25v-4h11v-9H13a4 4 0 01-4-4V19a4 4 0 014-4h50a4 4 0 014 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_TV.7ff0efff.svg";
export { SvgH1Tv as ReactComponent };